import { render } from "./Abhs.vue?vue&type=template&id=3da97440&scoped=true"
import script from "./Abhs.vue?vue&type=script&lang=js"
export * from "./Abhs.vue?vue&type=script&lang=js"

import "./Abhs.vue?vue&type=style&index=0&id=3da97440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da97440"]])

export default __exports__